import { defineMessages } from 'react-intl';

export default defineMessages({
  ariaLabel: {
    id: 'neptune.Info.ariaLabel',
    defaultMessage: 'More information',
  },
});
